// extracted by mini-css-extract-plugin
module.exports = {"textareaWrapper":"TextArea_textareaWrapper__wj5Rz","placeholder":"TextArea_placeholder__-rIIn"};